package pogolitics.controller

class MissingDataException(msg: String) : Exception(msg)
